import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

function BarcodeCode128Svg({ style = {width: "300px", height: "180px"}, color = "primary", viewBox = "0 0 290.000000 210.000000" }) {
    return (
        <SvgIcon color={color} style={style} viewBox={viewBox}>
            <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M390 1135 c0 -958 0 -965 20 -965 20 0 20 7 20 965 0 958 0 965 -20
                965 -20 0 -20 -7 -20 -965z"/>
                <path d="M470 1135 c0 -958 0 -965 20 -965 20 0 20 7 20 965 0 958 0 965 -20
                965 -20 0 -20 -7 -20 -965z"/>
                <path d="M550 1220 l0 -880 45 0 45 0 0 880 0 880 -45 0 -45 0 0 -880z"/>
                <path d="M720 1220 l0 -880 40 0 40 0 0 880 0 880 -40 0 -40 0 0 -880z"/>
                <path d="M890 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M1010 1220 l0 -880 40 0 40 0 0 880 0 880 -40 0 -40 0 0 -880z"/>
                <path d="M1140 1220 l0 -880 80 0 80 0 0 880 0 880 -80 0 -80 0 0 -880z"/>
                <path d="M1340 1220 l0 -880 25 0 25 0 0 880 0 880 -25 0 -25 0 0 -880z"/>
                <path d="M1470 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M1630 1220 l0 -880 25 0 25 0 0 880 0 880 -25 0 -25 0 0 -880z"/>
                <path d="M1720 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M1930 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M2010 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M2090 1220 l0 -880 85 0 85 0 0 880 0 880 -85 0 -85 0 0 -880z"/>
                <path d="M2300 1135 c0 -958 0 -965 20 -965 20 0 20 7 20 965 0 958 0 965 -20
                965 -20 0 -20 -7 -20 -965z"/>
                <path d="M2380 1135 l0 -965 25 0 25 0 0 965 0 965 -25 0 -25 0 0 -965z"/>
                <path d="M2470 1135 c0 -958 0 -965 20 -965 20 0 20 7 20 965 0 958 0 965 -20
                965 -20 0 -20 -7 -20 -965z"/>
                <path d="M77 269 c-45 -26 -61 -136 -29 -199 49 -98 162 -43 162 78 0 101 -65
                160 -133 121z m77 -32 c36 -27 33 -157 -5 -178 -49 -26 -89 15 -89 92 0 80 45
                121 94 86z"/>
                <path d="M618 273 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M883 273 c-7 -2 -13 -13 -13 -22 0 -16 4 -17 39 -8 53 14 91 -2 91
                -38 0 -18 -19 -46 -65 -93 -36 -36 -65 -72 -65 -79 0 -10 21 -13 80 -13 64 0
                80 3 80 15 0 12 -13 15 -57 15 l-57 0 40 43 c82 85 95 129 48 166 -25 20 -89
                27 -121 14z"/>
                <path d="M1183 273 c-7 -2 -13 -11 -13 -18 0 -9 11 -12 39 -8 44 6 81 -10 81
                -35 0 -27 -20 -42 -57 -42 -23 0 -33 -5 -33 -15 0 -10 10 -15 31 -15 62 0 89
                -38 52 -75 -13 -13 -29 -16 -70 -13 -38 3 -53 1 -53 -8 0 -24 75 -33 124 -14
                49 18 61 105 16 117 -18 5 -18 5 1 24 44 44 2 110 -70 108 -20 0 -42 -3 -48
                -6z"/>
                <path d="M1493 196 c-69 -110 -69 -116 7 -116 l60 0 0 -30 c0 -20 5 -30 15
                -30 10 0 15 10 15 30 0 23 4 30 20 30 11 0 20 7 20 15 0 8 -9 15 -20 15 -18 0
                -20 7 -20 85 0 81 -1 85 -22 85 -18 0 -35 -19 -75 -84z m64 -83 c-3 -2 -23 -3
                -45 -1 l-41 3 42 67 42 67 3 -66 c2 -36 1 -67 -1 -70z"/>
                <path d="M1750 216 l0 -64 40 5 c50 7 90 -16 90 -52 0 -37 -40 -59 -95 -53
                -32 4 -45 2 -45 -7 0 -44 146 -26 164 20 25 66 -20 125 -93 125 -28 0 -31 3
                -31 30 0 30 1 30 55 30 42 0 55 3 55 15 0 12 -14 15 -70 15 l-70 0 0 -64z"/>
                <path d="M2062 264 c-50 -34 -67 -120 -38 -189 37 -89 166 -66 166 30 0 70
                -83 112 -133 68 -20 -18 -20 -17 -13 12 10 45 43 68 88 62 27 -4 38 -1 38 8 0
                28 -72 34 -108 9z m82 -120 c34 -34 9 -94 -39 -94 -30 0 -55 25 -55 55 0 30
                25 55 55 55 13 0 31 -7 39 -16z"/>
                <path d="M2710 216 l0 -64 40 5 c50 7 90 -16 90 -52 0 -37 -40 -59 -95 -53
                -32 4 -45 2 -45 -7 0 -44 146 -26 164 20 25 66 -20 125 -93 125 -28 0 -31 3
                -31 30 0 30 1 30 55 30 42 0 55 3 55 15 0 12 -14 15 -70 15 l-70 0 0 -64z"/>
                </g>

        </SvgIcon>
    );
}

export default BarcodeCode128Svg;
